import React, { useCallback, useLayoutEffect } from 'react';
import {
  useRecoilValueLoadable,
  useSetRecoilState,
} from 'recoil';
import {
  previewScenarioQuery,
  questionIdState,
} from '../stores/query';
import WebInterview from '../components/webinterview/WebInterview';
import { scenarioState } from '../stores/scenarioState';

interface ListPageProp {
  token: string;
  questionId: number;
}

const PreviewPage = (props: ListPageProp) => {
  const setQuestionId = useSetRecoilState(questionIdState);
  useLayoutEffect(() => {
    setQuestionId(props.questionId)
  }, [props, setQuestionId]);

  if (props.token === null) {
    return (<h1>404 Page Not Found.</h1>)
  }
  return (
    <React.Suspense fallback={"loading..."}>
      <PreviewPageInner/>
    </React.Suspense>
  );
};

const PreviewPageInner = () => {
  const originalScenario = useRecoilValueLoadable(previewScenarioQuery);
  const setScenario = useSetRecoilState(scenarioState);
  const {state, contents} = useRecoilValueLoadable(scenarioState);

  useLayoutEffect(() => {
    if (originalScenario.state === 'hasValue') {
      setScenario(originalScenario.contents);
    }
  }, [originalScenario, originalScenario.state, originalScenario.contents, setScenario]);

  const complete = useCallback(() => { /*noop*/ }, []);

  switch (state) {
    case 'loading':
      return (<span>Loading...</span>);
    case 'hasError':
      return (<h1>Error {contents} </h1>)
    case 'hasValue':
      return (<WebInterview onCompleted={complete}/>);
  }
}

export default PreviewPage;
